import { Link } from 'react-router-dom';

import { Box, Image, useComputedColorScheme } from '@mantine/core';

import { useAuth } from '@clerk/react';

interface HeaderLogoProps {
  width?: number | string;
  height?: number | string;
}
// Logo intrinsic aspect ratio is 2332:626 (~3.725:1); width defaults to match
// height=32 so the <img> always carries explicit dimensions and the browser can
// reserve space before load (avoids cumulative layout shift).
export function HeaderLogo({ width = 119, height = 32 }: HeaderLogoProps) {
  const { isSignedIn } = useAuth();
  const colorScheme = useComputedColorScheme('dark');

  return (
    <Box py="xs">
      <Link
        to={isSignedIn ? '/app/pipeline' : '/'}
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <Image
          src={
            colorScheme === 'dark' ? '/images/dark/logo-sized.png' : '/images/light/logo-sized.png'
          }
          width={width}
          height={height}
          alt="Assay Logo"
          style={{ display: 'inline-block' }}
        />
      </Link>
    </Box>
  );
}
